'use strict';

/* jshint -W098 */
angular.module('mean.map').controller('MapLocatorController', ['$scope', 'Global', 'MeanUser', 'userService', 'builderService', 'ngDialog', 'toaster', '$filter', 'contactService', 'Trades', 'Builders', 'Projects', 'ProjectHours', 'aceUtils', 'Users', 'Materials', 'taskListService', 'tradeCodeService', 'Equipments', 'Timecards', 'Hours', 'taskService', '$q', 
  function($scope, Global, MeanUser, userService, builderService, ngDialog, toaster, $filter, contactService, Trades, Builders, Projects, ProjectHours, aceUtils, Users, Materials, taskListService, tradeCodeService, Equipments, Timecards, Hours, taskService, $q) {
    $scope.global = Global;
    $scope.package = {
      name: 'map'
    };

    var clockInData = {};
    var clockOutData = {};
    var lunchBeginsData = {};
    var lunchEndsData = {};
    var map = null;
    var projectsData = {};
    var clockInMarkers = [];
    var clockOutMarkers = [];
    var lunchBeginssMarkers = [];
    var lunchEndsMarkers = [];
    var companyOfficeCoordinates = [];

    $scope.employees = [];
    $scope.projects = [];
    $scope.all_projects = [];
    $scope.startDate = new Date();
    $scope.endDate = new Date();
    $scope.clockIn = true;
    $scope.clockOut = true;
    $scope.lunchBegins = true;
    $scope.lunchEnds = true;
    $scope.menNeeded = true;
    $scope.actualMen = true;

    $scope.startDate.setHours(0);
    $scope.startDate.setMinutes(0);
    $scope.startDate.setSeconds(0);
    $scope.endDate.setHours(23);
    $scope.endDate.setMinutes(59);
    $scope.endDate.setSeconds(59);
    
    //user data record of the logged in user
    $scope.user = MeanUser.user;
    console.log('Got user data record' + $scope.user);

    $scope.getResults = function() {
        clockInMarkers = [];
        clockOutMarkers = [];
        lunchBeginssMarkers = [];
        lunchEndsMarkers = [];

        if(!$scope.clockIn && !$scope.clockOut &&
            !$scope.lunchBegins && !$scope.lunchEnds) {
            toaster.pop('error', 'Clock Selection Error',
                'Please select a clock type');
            return;
        }
        // Timecards.query({
        //     'trade_code': userService.getTradeCode($scope.user.username),
        //     'company_code': $scope.user.contractor_code 
        // }, function(retData) {
        //     $scope.timecards = retData;

        // });

        projectsData.features = [];
        $scope.all_projects.forEach(function(project) {
          
          var item = {};
          item.properties = [];
          item.geometry = {};
          var subItem = {};
          subItem.projectName = project.name;
          subItem._id = project._id;
          subItem.needed = 0;
          subItem.actual = 0;
          item.properties.push(subItem);

          if (project.contact.lat == null) {
            item.geometry.coordinates = companyOfficeCoordinates;  
          }
          else {
            item.geometry.coordinates = [project.contact.lat, project.contact.lng];
          }
          projectsData.features.push(item);
        });

        // projectsData.features.forEach(function(project) {
        //   taskService.getByTradeAndDateRange('', $scope.user.trade[0], project.properties[0]._id, '', '', '', $scope.user.username, $scope.startDate, $scope.endDate, false).then(function(tasks) {
        //     for(var i = 0; i <= tasks.length - 1; i++) {
        //       project.properties[0].needed += tasks[i].bid_hours;
        //       project.properties[0].actual += tasks[i].actual_man_hours;
        //     }
        //   });
        // });

        if(this.selectedEmployee) {
            Hours.query({
                'trade_code': userService.getTradeCode($scope.user.username),
                'company_code': $scope.user.contractor_code ,
                'type': 'UserDateRange',
                'start': $scope.startDate,
                'end': $scope.endDate,
                'user': this.selectedEmployee._id,
            }, function(retData) {
                clockInData = _.cloneDeep(retData);
                clockOutData = _.cloneDeep(retData);
                lunchBeginsData = _.cloneDeep(retData);
                lunchEndsData = _.cloneDeep(retData);

                $scope.totalEmployees = 1;

                $scope.initMap();
            });
        } else {
            Hours.query({
                'trade_code': userService.getTradeCode($scope.user.username),
                'company_code': $scope.user.contractor_code,
                'type': 'AllDateRange',
                'start': $scope.startDate,
                'end': $scope.endDate,
            }, function(retData) {
                clockInData = _.cloneDeep(retData);
                clockOutData = _.cloneDeep(retData);
                lunchBeginsData = _.cloneDeep(retData);
                lunchEndsData = _.cloneDeep(retData);

                $scope.initMap();

                var users = [];
                _.each(retData, function(item) {
                    if(users.indexOf(item.user.username) === -1) {
                        users.push(item.user.username);
                    }
                });

                $scope.totalEmployees = users.length;
            });
        }
    };

    // $scope.getBuilderList = function(builders) {
    //   var deferred = $q.defer();
    //   var returned_items = [];

    //   _.each(builders, function(builder) {
    //     Builders.query({'builder': builder._id}, function(builders) {
    //       var builder = builders[0];
    //       builder.company_code = aceUtils.padDigits(builder.company_code, 3);
    //       builder.trade_code = builder.trade_code?builder.trade_code:
    //                                   tradeCodeService.getCode(builder.trade)
    //       returned_items.push(builder);
    //     });
    //   });

    //   $q.all(returned_items).then(function(results) {
    //     deferred.resolve(results);
    //   });

    //   return deferred.promise;
    // };

    $scope.init = function() {
      $scope.is_admin = userService.isAdmin($scope.user);
      // if($scope.is_admin) {
      //   Projects.query({'trade_code': tradeCodeService.getCode($scope.user.trade[0]), 
      //     'complete': false,
      //     'company_code': $scope.user.contractor_code }, function(projects) {
      //     $scope.projects = projects;
      //     userService.getMainAccount($scope.user.username).then(function(user) {
      //       Projects.query({
      //         'trade_code': '00',
      //         'complete': false,
      //         'trades.main_username': user.username }
      //         , function(projects) {
      //             for(var i=0; i<projects.length; i++)
      //               $scope.projects.push(projects[i]);
      //       });

      //       Trades.query({'main_account_id': user._id}, function(trade) {
      //         if(trade.length === 0) return;

      //         trade[0].company_code =
      //             aceUtils.padDigits(trade[0].company_code, 3);
      //         trade[0].trade_code = tradeCodeService.getCode(trade[0].trade);
      //         $scope.my_trade = trade[0];
      //       });
      //     });
      //   }); 
      // } else {
      //   Projects.query({'complete': false,
      //     'trades.manager.username': $scope.user.username}, function(projects) {
      //     $scope.projects = projects;
      //   });

      //   userService.getMainAccount($scope.user.username).then(function(user) {
      //     Trades.query({'main_account_id': user._id}, function(trade) {
      //       if(trade.length === 0) return;

      //       trade[0].company_code =
      //           aceUtils.padDigits(trade[0].company_code, 3);
      //       trade[0].trade_code = tradeCodeService.getCode(trade[0].trade);
      //       $scope.my_trade = trade[0];
      //     });
      //   });
      // }

        // Users.query({
        //     'trade': MeanUser.user.trade[0], 
        //     'contractor_code': $scope.contractor_code}, function(users) {
        //     $scope.users = users;
        //     $scope.totalEmployees = $scope.users.length - 1;
        //     var temp = $filter('filter')($scope.users, {'roles': 'foreman'}, true);
        // });
    };

    userService.getMainAccount($scope.user.username).then(function(main_account) {
      $scope.main_account = main_account;
      contactService.getMyContacts($scope.main_account._id).then(function(contacts) {
        $scope.builders = [];
        console.log('getting contacts');

        Trades.query({'main_account_id': $scope.main_account._id}, function(trade) {
          $scope.users_trade_account = trade[0];

          var geocoder = new google.maps.Geocoder();

          geocoder.geocode( { 'address' : $scope.users_trade_account.address_one + " " + $scope.users_trade_account.city + " " + $scope.users_trade_account.state }, function( results, status ) {
            companyOfficeCoordinates = [results[0].geometry.location.lat(), results[0].geometry.location.lng()];
          });

          trade[0].company_code =
                  aceUtils.padDigits(trade[0].company_code, 3);
          trade[0].trade_code = tradeCodeService.getCode(trade[0].trade);
          $scope.builders.push(trade[0]);

          Projects.query({ 'complete': false,
            'company_code': trade[0].company_code, 
            'trade_code': trade[0].trade_code }, function(projects) {
            
            projects.forEach(function(project) {
              $scope.all_projects.push(project);
            });
          });

          contacts.builders.forEach(function(builder) {
            Builders.query({'builder': builder._id}, function(builders) {
              if(builders.length === 0) return;
              builders[0].company_code =
                  aceUtils.padDigits(builders[0].company_code, 3);
              builders[0].trade_code = '00';
              $scope.builders.push(builders[0]);
              Projects.query({ 'complete': false,
                'company_code': builders[0].company_code, 
                'trade_code': builders[0].trade_code,
                'match_string': true,
                'username': $scope.main_account.username }, function(projects) {
                
                projects.forEach(function(project) {
                  $scope.all_projects.push(project);
                });
              });
            });
          });
        });
      });
    });

    Users.query({'trade': $scope.user.trade[0],
      //'active': true,
      'contractor_code': $scope.user.contractor_code}, function(users) {
      users.forEach(function(user) {
        if(user.roles[0] === 'tm_admin') {
          user.role = 'Admin'; //not used yet but might be in future
        } else if(user.roles[0] === 'tm_office') {
          user.role = 'Office'; //not used yet but might be in future
        } else if(user.roles[0] === 'tm') {
          user.role = 'Manager'; //not used yet but might be in future
        } else if(user.roles[0] === 'foreman') {
          user.role = 'Foreman';
          $scope.employees.push(user);
        } else {
          user.role = 'Tradesman';
          $scope.employees.push(user);
        }
      });
    });

    $scope.changeBuilder = function() {
        if(!$scope.selectedBuilder) return;
        $scope.projects = [];
        $scope.tasks = [];
        $scope.phases = [];
        $scope.lots = [];
        $scope.bid_tasks = [];
        $scope.trades = [];

        var company_code = aceUtils.padDigits($scope.selectedBuilder.company_code, 3);
        var trade_code = $scope.selectedBuilder.trade_code?
                $scope.selectedBuilder.trade_code:
                tradeCodeService.getCode($scope.selectedBuilder.trade)

        $scope.projects = $filter('filter')($scope.all_projects, {
            'company_code': company_code, 
            'trade_code': trade_code }, true);
    };

    $scope.changeProject = function() {
    
    };

    $scope.dateRangeUpdated = function() {
      $scope.startDate = new Date($scope.mapDateRange.startDate);
      $scope.endDate = new Date($scope.mapDateRange.endDate);

      $scope.startDate.setHours(0);
      $scope.startDate.setMinutes(0);
      $scope.startDate.setSeconds(0);
      $scope.endDate.setHours(23);
      $scope.endDate.setMinutes(59);
      $scope.endDate.setSeconds(59);
    };

    $scope.selectClockIn = function() {
      if ($scope.clockIn == false) {
        clockInMarkers.forEach(function(marker) {
          marker.remove();
        });
      }
      else {
        clockInMarkers.forEach(function(marker) {
          marker.addTo(map);
        });
      }
    };

    $scope.selectClockOut = function() {
      if ($scope.clockOut == false) {
        clockOutMarkers.forEach(function(marker) {
          marker.remove();
        });
      }
      else {
        clockOutMarkers.forEach(function(marker) {
          marker.addTo(map);
        });
      }
      
    };

    $scope.selectLunchBegins = function() {
      if ($scope.lunchBegins == false) {
        lunchBeginssMarkers.forEach(function(marker) {
          marker.remove();
        });
      }
      else {
        lunchBeginssMarkers.forEach(function(marker) {
          marker.addTo(map);
        });
      }
      
    };

    $scope.selectLunchEnds = function() {
      if ($scope.lunchEnds == false) {
        lunchEndsMarkers.forEach(function(marker) {
          marker.remove();
        });
      }
      else {
        lunchEndsMarkers.forEach(function(marker) {
          marker.addTo(map);
        });
      }
    };

    $scope.selectMenNeeded = function() {
      console.log("Click Men Needed", $scope.menNeeded);
    };

    $scope.selectActualMen = function() {
      console.log("Click Actual Men", $scope.actualMen);
    }; 

    Users.query({
      'trade': $scope.user.trade[0], 
      'contractor_code': $scope.user.contractor_code
    }, function(retUsers) {
      $scope.users = retUsers;
      
      // Timecards.query({
      //   'trade_code': userService.getTradeCode($scope.user.username),
      //   'company_code': $scope.user.contractor_code 
      // }, function(retData) {
      //   $scope.timecards = retData;
      //   _.each($scope.timecards, function(card) {
      //       card.user_name = $filter('filter')($scope.users, {
      //           '_id': card.user }, true)[0].name;
      //   });
        
      // });
      // Hours.query({
      //   'trade_code': userService.getTradeCode($scope.user.username),
      //   'company_code': $scope.user.contractor_code 
      // }, function(retData) {

      //   clockInData = _.cloneDeep(retData);
      //   clockOutData = _.cloneDeep(retData);
      //   lunchBeginsData = _.cloneDeep(retData);
      //   lunchEndsData = _.cloneDeep(retData);
        
      //   $scope.buildMap();
      
      // });
    });

    $scope.initMap = function() {
      var mapOptions = {
        center: {lat: 36.68439495770039, lng: -121.6590145864398},
        zoom: 18,
        scrollwheel: true,
        scaleControl: true,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        zoomControl: true,
        zoomControlOptions: {
          style: google.maps.ZoomControlStyle.LARGE,
          position: google.maps.ControlPosition.RIGHT_TOP
        },
        panControl: true,
          panControlOptions: {
          position: google.maps.ControlPosition.TOP_RIGHT
        }
      };
    
      var coordinates = [];
      for (var i = 0; i < clockInData.length; i++) {
        if (clockInData[i].clock_in && clockInData[i].clock_in.location != undefined)
          coordinates.push(new google.maps.LatLng(clockInData[i].clock_in.location.lat, clockInData[i].clock_in.location.lon));
        if (clockInData[i].clock_out && clockInData[i].clock_out.location != undefined)
          coordinates.push(new google.maps.LatLng(clockInData[i].clock_out.location.lat, clockInData[i].clock_out.location.lon));
        if (clockInData[i].lunch_start && clockInData[i].lunch_start.location != undefined)
          coordinates.push(new google.maps.LatLng(clockInData[i].lunch_start.location.lat, clockInData[i].lunch_start.location.lon));
        if (clockInData[i].lunch_end && clockInData[i].lunch_end.location != undefined)
          coordinates.push(new google.maps.LatLng(clockInData[i].lunch_end.location.lat, clockInData[i].lunch_end.location.lon));
      }

      for (var i = 0; i < projectsData.features.length; i++) {
        coordinates.push(new google.maps.LatLng(projectsData.features[i].geometry.coordinates[0], projectsData.features[i].geometry.coordinates[1]));
      }

      map = new google.maps.Map(document.getElementById('map'), mapOptions);
    
      if (coordinates.length > 0) {
        var bounds = new google.maps.LatLngBounds();
        for(var i = 0; i < coordinates.length; i++) {
          bounds.extend(coordinates[i])
        }
        map.fitBounds(bounds);
      }

      google.maps.event.addListenerOnce(map, 'tilesloaded', function(){

        $scope.buildProjectsMarkers();
        $scope.buildCompanyOfficeMarker();
        $scope.buildClockInMarkers();
        $scope.buildClockOutMarkers();
        $scope.buildLunchBeginsMarkers();
        $scope.buildLunchEndsMarkers();

      });
    }

    $scope.buildProjectsMarkers = function() {

      for (var i = 0; i < projectsData.features.length; i ++) {
        var retLocation = projectsData.features[i].geometry.coordinates;
        var index = projectsData.features.findIndex(function (item) {
          var location = item.geometry.coordinates;
          return retLocation[0] == location[0] && retLocation[1] == location[1];
        });
        projectsData.features[i].badge = 1;    
        projectsData.features[i].infoArray = [projectsData.features[i].properties[0].projectName];
        
        if (index < i) {
          projectsData.features[index].badge += 1;
          projectsData.features[index].infoArray.push(projectsData.features[i].properties[0].projectName);
          projectsData.features.splice(i, 1);
          i -= 1;
        }
      }

      var icon = {
        url: "map/assets/img/House.png", // url
        scaledSize: new google.maps.Size(50, 50), // scaled size
        origin: new google.maps.Point(0,0), // origin
        anchor: new google.maps.Point(25, 25) // anchor
      };

      var markers = projectsData.features.map(function(data) {
        var marker;
        var details = document.createElement('div');
        details.classList.add('marker-details');
        var htmlText = `<div>`;
        for (var i = 0; i < data.properties.length; i++) {
          htmlText += `
            <div class="group">
              <h4 class="title">` + data.properties[i].projectName + `</h4>
              <div class="content">
                <div class="needed">
                  <p>Needed</p>
                  <p>` + data.properties[i].needed.toFixed(2) + `</p>
                </div>
                <div class="actual">
                  <p>Actual</p>
                  <p>` + data.properties[i].actual.toFixed(2) + `</p>
                </div>
              </div>
            </div>
          `;
        }
        htmlText += `</div>`;
        details.innerHTML = htmlText;

        var infoWindow = new google.maps.InfoWindow({
          content: details
        });

        marker = new google.maps.Marker({
          position: {lat: data.geometry.coordinates[0], lng: data.geometry.coordinates[1]},
          icon: icon,
          zIndex: 100,
          infoArray: data.infoArray
        });
        marker.addListener('mouseover', function() {
          infoWindow.open(map, this);
        });
      
        var clicked = false;
        marker.addListener('click', function() {
          clicked = true;
          infoWindow.open(map, this);
        });
      
        marker.addListener('mouseout', function() {
          if (clicked == false){
            infoWindow.close();
          }
        });
        
        google.maps.event.addListener(infoWindow,'closeclick',function(){
          clicked = false;
        });

        return marker;
      });

      var clusterStyles = [
        {
          textColor: 'white',
          url: 'map/assets/img/House1.png',
          height: 50,
          width: 50
        }
      ];

      var mcOptions = {
        gridSize: 50,
        styles: clusterStyles,
        maxZoom: 15,
        zoomOnClick: false,
      };
      var markerClusterer = new MarkerClusterer(map, markers, mcOptions);

      google.maps.event.addListener(markerClusterer, 'clusterclick', function (cluster) {
        
        var markers = cluster.getMarkers();
    
        var content = '';
        content = `<div>`;
        for (var i = 0; i < markers.length; i++) {
          for (var j = 0; j < markers[i].infoArray.length; j++) {
            content += `
              <div class="group">
                <p>` + markers[i].infoArray[j] + `</p>
              </div>
            `;
          }
        }
        content += `</div>`;
        var infowindow = new google.maps.InfoWindow();
        infowindow.setPosition(cluster.getCenter());
        infowindow.setContent(content);
        infowindow.open(map);
        google.maps.event.addListener(map, 'zoom_changed', function () {
            infowindow.close();
        });
      });
    }

    $scope.buildCompanyOfficeMarker = function() {

      var icon = {
        url: "map/assets/img/star.png", // url
        scaledSize: new google.maps.Size(40, 40), // scaled size
        origin: new google.maps.Point(0,0), // origin
        anchor: new google.maps.Point(20, 20) // anchor
      };

      var officeMarker = new google.maps.Marker({
        position: {lat: companyOfficeCoordinates[0], lng: companyOfficeCoordinates[1]},
        icon: icon,
        map: map,
        zIndex: 101
      });
      
    }

    $scope.buildClockInMarkers = function() {

      for (var i = 0; i < clockInData.length; i ++) {
        if (clockInData[i].clock_in) {
          var retLocation = clockInData[i].clock_in.location;
          var index = clockInData.findIndex(function (item) {
            if (item.clock_in) {
              var location = item.clock_in.location;
              return retLocation.lat == location.lat && retLocation.lon == location.lon;
            }
          });
          clockInData[i].badge = 1;
          clockInData[i].infoArray = [ moment(clockInData[i].clock_in.time).format('MMM DD YYYY') + ': ' 
            + clockInData[i].user.name + ' (' + clockInData[i].user.username + ') ' +  moment(clockInData[i].clock_in.time).format("h:mm:ss a") ];
          if (index < i) {
            clockInData[index].badge += 1;
            clockInData[index].infoArray.push(moment(clockInData[i].clock_in.time).format('MMM DD YYYY') + ': ' 
              + clockInData[i].user.name + ' (' + clockInData[i].user.username + ') ' +  moment(clockInData[i].clock_in.time).format("h:mm:ss a"));
            clockInData.splice(i, 1);
            i -= 1;
          }
        }
      }

      var icon = {
        url: "map/assets/img/Human_Green.png", // url
        scaledSize: new google.maps.Size(35, 35), // scaled size
        origin: new google.maps.Point(0,0), // origin
        anchor: new google.maps.Point(-18, 0) // anchor
      };
      
      var markers = clockInData.map(function(data) {
        var marker;
        if (data.clock_in) {
          var infoWindow = new google.maps.InfoWindow({
            content: $scope.clockingMakerHtml(data)
          });

          marker = new google.maps.Marker({
            position: {lat: data.clock_in.location.lat, lng: data.clock_in.location.lon},
            icon: icon,
            zIndex: 100,
            infoArray: data.infoArray
          });
          marker.addListener('mouseover', function() {
            infoWindow.open(map, this);
          });

          var clicked = false;
          marker.addListener('click', function() {
            clicked = true;
            infoWindow.open(map, this);
          });
        
          marker.addListener('mouseout', function() {
            if (clicked == false){
              infoWindow.close();
            }
          });
          
          google.maps.event.addListener(infoWindow,'closeclick',function(){
            clicked = false;
          });

          return marker;
        }
      });

      var clusterStyles = [
        {
          textColor: 'white',
          url: 'map/assets/img/Human_Green1.png',
          height: 35,
          width: 35
        }
      ];

      var mcOptions = {
        gridSize: 35,
        styles: clusterStyles,
        maxZoom: 15,
        zoomOnClick: false
      };
      var markerClusterer = new MarkerClusterer(map, markers, mcOptions);
      google.maps.event.addListener(markerClusterer, 'clusterclick', function (cluster) {
        
        var markers = cluster.getMarkers();
    
        var content = '';
        content = `<div>`;
        for (var i = 0; i < markers.length; i++) {
          for (var j = 0; j < markers[i].infoArray.length; j++) {
            content += `
              <div class="group">
                <p>` + markers[i].infoArray[j] + `</p>
              </div>
            `;
          }
        }
        content += `</div>`;
        var infowindow = new google.maps.InfoWindow();
        infowindow.setPosition(cluster.getCenter());
        infowindow.setContent(content);
        infowindow.open(map);
        google.maps.event.addListener(map, 'zoom_changed', function () {
            infowindow.close();
        });
      });
    }

    $scope.buildClockOutMarkers = function() {

      for (var i = 0; i < clockOutData.length; i ++) {
        if (clockOutData[i].clock_out) {
          var retLocation = clockOutData[i].clock_out.location;
          var index = clockOutData.findIndex(function (item) {
            if (item.clock_out) {
              var location = item.clock_out.location;
              return retLocation.lat == location.lat && retLocation.lon == location.lon;
            }
          });
          clockOutData[i].badge = 1;
          clockOutData[i].infoArray = [ moment(clockOutData[i].clock_out.time).format('MMM DD YYYY') + ': ' 
            + clockOutData[i].user.name + ' (' + clockOutData[i].user.username + ') ' +  moment(clockOutData[i].clock_out.time).format("h:mm:ss a") ];
          if (index < i) {
            clockOutData[index].badge += 1;
            clockOutData[index].infoArray.push(moment(clockOutData[i].clock_out.time).format('MMM DD YYYY') + ': ' 
              + clockOutData[i].user.name + ' (' + clockOutData[i].user.username + ') ' +  moment(clockOutData[i].clock_out.time).format("h:mm:ss a"));
            clockOutData.splice(i, 1);
            i -= 1;
          }
        }
      }

      var icon = {
        url: "map/assets/img/Human_Red.png", // url
        scaledSize: new google.maps.Size(35, 35), // scaled size
        origin: new google.maps.Point(0,0), // origin
        anchor: new google.maps.Point(-6, 0) // anchor
      };
      
      var markers = clockOutData.map(function(data) {
        var marker;
        if (data.clock_out){
          var infoWindow = new google.maps.InfoWindow({
            content: $scope.clockingMakerHtml(data)
          }); 

          marker = new google.maps.Marker({
            position: {lat: data.clock_out.location.lat, lng: data.clock_out.location.lon},
            icon: icon,
            zIndex: 100,
            infoArray: data.infoArray
          });
          marker.addListener('mouseover', function() {
            infoWindow.open(map, this);
          });
        
          var clicked = false;
          marker.addListener('click', function() {
            clicked = true;
            infoWindow.open(map, this);
          });
        
          marker.addListener('mouseout', function() {
            if (clicked == false){
              infoWindow.close();
            }
          });
          
          google.maps.event.addListener(infoWindow,'closeclick',function(){
            clicked = false;
          });

          return marker;
        }
      });

      var clusterStyles = [
        {
          textColor: 'white',
          url: 'map/assets/img/Human_Red1.png',
          height: 35,
          width: 35
        }
      ];

      var mcOptions = {
        gridSize: 35,
        styles: clusterStyles,
        maxZoom: 15,
        zoomOnClick: false
      };
      var markerClusterer = new MarkerClusterer(map, markers, mcOptions);
      google.maps.event.addListener(markerClusterer, 'clusterclick', function (cluster) {
        
        var markers = cluster.getMarkers();
    
        var content = '';
        content = `<div>`;
        for (var i = 0; i < markers.length; i++) {
          for (var j = 0; j < markers[i].infoArray.length; j++) {
            content += `
              <div class="group">
                <p>` + markers[i].infoArray[j] + `</p>
              </div>
            `;
          }
        }
        content += `</div>`;
        var infowindow = new google.maps.InfoWindow();
        infowindow.setPosition(cluster.getCenter());
        infowindow.setContent(content);
        infowindow.open(map);
        google.maps.event.addListener(map, 'zoom_changed', function () {
            infowindow.close();
        });
      });
    }

    $scope.buildLunchBeginsMarkers = function() {

      for (var i = 0; i < lunchBeginsData.length; i ++) {
        if (lunchBeginsData[i].lunch_start) {
          var retLocation = lunchBeginsData[i].lunch_start.location;
          var index = lunchBeginsData.findIndex(function (item) {
            if (item.lunch_start) {
              var location = item.lunch_start.location;
              return retLocation.lat == location.lat && retLocation.lon == location.lon;
            }
          });
          lunchBeginsData[i].badge = 1;
          lunchBeginsData[i].infoArray = [ moment(lunchBeginsData[i].lunch_start.time).format('MMM DD YYYY') + ': ' 
            + lunchBeginsData[i].user.name + ' (' + lunchBeginsData[i].user.username + ') ' +  moment(lunchBeginsData[i].lunch_start.time).format("h:mm:ss a") ];
          if (index < i) {
            lunchBeginsData[index].badge += 1;
            lunchBeginsData[index].infoArray.push(moment(lunchBeginsData[i].lunch_start.time).format('MMM DD YYYY') + ': ' 
              + lunchBeginsData[i].user.name + ' (' + lunchBeginsData[i].user.username + ') ' +  moment(lunchBeginsData[i].lunch_start.time).format("h:mm:ss a"));
            lunchBeginsData.splice(i, 1);
            i -= 1;
          }
        }
      }

      var icon = {
        url: "map/assets/img/Human_Blue.png", // url
        scaledSize: new google.maps.Size(35, 35), // scaled size
        origin: new google.maps.Point(0,0), // origin
        anchor: new google.maps.Point(6, 0) // anchor
      };
      
      var markers = lunchBeginsData.map(function(data) {
        var marker;
        if (data.lunch_start) {
          var infoWindow = new google.maps.InfoWindow({
            content: $scope.clockingMakerHtml(data)
          });

          marker = new google.maps.Marker({
            position: {lat: data.lunch_start.location.lat, lng: data.lunch_start.location.lon},
            icon: icon,
            zIndex: 100,
            infoArray: data.infoArray
          });
          marker.addListener('mouseover', function() {
            infoWindow.open(map, this);
          });
        
          var clicked = false;
          marker.addListener('click', function() {
            clicked = true;
            infoWindow.open(map, this);
          });
        
          marker.addListener('mouseout', function() {
            if (clicked == false){
              infoWindow.close();
            }
          });
          
          google.maps.event.addListener(infoWindow,'closeclick',function(){
            clicked = false;
          });

          return marker;
        }
      });

      var clusterStyles = [
        {
          textColor: 'white',
          url: 'map/assets/img/Human_Blue1.png',
          height: 35,
          width: 35
        }
      ];

      var mcOptions = {
        gridSize: 35,
        styles: clusterStyles,
        maxZoom: 15,
        zoomOnClick: false
      };
      var markerClusterer = new MarkerClusterer(map, markers, mcOptions);
      google.maps.event.addListener(markerClusterer, 'clusterclick', function (cluster) {
        
        var markers = cluster.getMarkers();
    
        var content = '';
        content = `<div>`;
        for (var i = 0; i < markers.length; i++) {
          for (var j = 0; j < markers[i].infoArray.length; j++) {
            content += `
              <div class="group">
                <p>` + markers[i].infoArray[j] + `</p>
              </div>
            `;
          }
        }
        content += `</div>`;
        var infowindow = new google.maps.InfoWindow();
        infowindow.setPosition(cluster.getCenter());
        infowindow.setContent(content);
        infowindow.open(map);
        google.maps.event.addListener(map, 'zoom_changed', function () {
            infowindow.close();
        });
      });
    }

    $scope.buildLunchEndsMarkers = function() { 

      for (var i = 0; i < lunchEndsData.length; i ++) {
        if (lunchEndsData[i].lunch_end && lunchEndsData[i].lunch_end.location) {
          var retLocation = lunchEndsData[i].lunch_end.location;
          var index = lunchEndsData.findIndex(function (item) {
            if (item.lunch_end && item.lunch_end.location) {
              var location = item.lunch_end.location;
              return retLocation.lat == location.lat && retLocation.lon == location.lon;
            }
          });
          lunchEndsData[i].badge = 1;
          lunchEndsData[i].infoArray = [ moment(lunchEndsData[i].lunch_end.time).format('MMM DD YYYY') + ': ' 
            + lunchEndsData[i].user.name + ' (' + lunchEndsData[i].user.username + ') ' +  moment(lunchEndsData[i].lunch_end.time).format("h:mm:ss a") ];
          if (index < i) {
            lunchEndsData[index].badge += 1;
            lunchEndsData[index].infoArray.push(moment(lunchEndsData[i].lunch_end.time).format('MMM DD YYYY') + ': ' 
              + lunchEndsData[i].user.name + ' (' + lunchEndsData[i].user.username + ') ' +  moment(lunchEndsData[i].lunch_end.time).format("h:mm:ss a"));
            lunchEndsData.splice(i, 1);
            i -= 1;
          }
        }
      }

      var icon = {
        url: "map/assets/img/Human_Yellow.png", // url
        scaledSize: new google.maps.Size(35, 35), // scaled size
        origin: new google.maps.Point(0,0), // origin
        anchor: new google.maps.Point(18, 0) // anchor
      };
      
      var markers = lunchEndsData.map(function(data) {
        var marker;
        if (data.lunch_end && data.lunch_end.location) {
          var infoWindow = new google.maps.InfoWindow({
            content: $scope.clockingMakerHtml(data)
          });

          marker = new google.maps.Marker({
            position: {lat: data.lunch_end.location.lat, lng: data.lunch_end.location.lon},
            icon: icon,
            zIndex: 100,
            infoArray: data.infoArray
          });
          marker.addListener('mouseover', function() {
            infoWindow.open(map, this);
          });
        
          var clicked = false;
          marker.addListener('click', function() {
            clicked = true;
            infoWindow.open(map, this);
          });
        
          marker.addListener('mouseout', function() {
            if (clicked == false){
              infoWindow.close();
            }
          });
          
          google.maps.event.addListener(infoWindow,'closeclick',function(){
            clicked = false;
          });

          return marker;
        }
      });

      var clusterStyles = [
        {
          textColor: 'white',
          url: 'map/assets/img/Human_Yellow1.png',
          height: 35,
          width: 35
        }
      ];

      var mcOptions = {
        gridSize: 35,
        styles: clusterStyles,
        maxZoom: 15,
        zoomOnClick: false
      };
      var markerClusterer = new MarkerClusterer(map, markers, mcOptions);
      google.maps.event.addListener(markerClusterer, 'clusterclick', function (cluster) {
        
        var markers = cluster.getMarkers();
    
        var content = '';
        content = `<div>`;
        for (var i = 0; i < markers.length; i++) {
          for (var j = 0; j < markers[i].infoArray.length; j++) {
            content += `
              <div class="group">
                <p>` + markers[i].infoArray[j] + `</p>
              </div>
            `;
          }
        }
        content += `</div>`;
        var infowindow = new google.maps.InfoWindow();
        infowindow.setPosition(cluster.getCenter());
        infowindow.setContent(content);
        infowindow.open(map);
        google.maps.event.addListener(map, 'zoom_changed', function () {
            infowindow.close();
        });
      });
    }

    $scope.clockingMakerHtml = function(marker) {
      var details = document.createElement('div');
      details.classList.add('clocking-marker-details');

      var htmlText = `<div>`;
      if (marker.infoArray != undefined) {
        for (var i = 0; i < marker.infoArray.length; i++) {
          htmlText += `
            <div class="group">
              <p>` + marker.infoArray[i] + `</p>
            </div>
          `;
        }
      }
      htmlText += `</div>`;

      details.innerHTML = htmlText;
      return details;
    }

  }
]);
 


// WEBPACK FOOTER //
// ./packages/custom/map/public/controllers/map_locator.js